module.exports = __webpack_public_path__ + "static/media/ic_color_splash_seq_04.c94a7bd9.png";